export default {
  en: {
    url: 'URL',
    organizer: 'Organizer',
    cards: 'Cards',
    location: 'Posting Location',
    updated: 'Last updated',
    status: {
      uninitialized: 'Import not initialized yet',
      working: 'Import working',
      broken: 'Something has gone wrong with the import',
      inactive: 'Import inactive',
      processing: 'Please wait, importing...',
    },
    posting_location: {
      public: 'Public posts',
      group: 'External posts',
      forum: 'Forum posts',
    },
  },
};
